<app-tree-table [columns]="columns" [firstColumnFrozen]="true" [loading]="loading" [value]="value"></app-tree-table>
